import { Injectable } from '@angular/core';
import { ApiService } from './api.service';


@Injectable()
export class InsuranceService {

  constructor(private apiService: ApiService) {
  }

  get() {
    return this.apiService.get(
      '/insurance'
    );
  }

}
